import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

export function RescheduleDeferredDialog(props: {
  open: boolean;
  onClose: () => void;
  onConfirm: (newScheduledAt: string) => void;
}) {
  const [value, setValue] = useState("");

  function handleConfirm() {
    props.onConfirm(value);
    setValue("");
  }

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Перенос отложенной публикации</DialogTitle>
      <DialogContent>
        <TextField
          label="Новая дата и время публикации"
          type="datetime-local"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          fullWidth
          size="small"
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Отмена</Button>
        <Button onClick={handleConfirm} variant="contained" disabled={value === ""}>
          Перенести
        </Button>
      </DialogActions>
    </Dialog>
  );
}
